import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EventMapScopedProps } from '../../../types';
import { DEFAULT_ZOOM } from '../../_shared/constants';
import { DetailList } from '../../_shared/Detail/Detail';
import {
    EventDetailsMainInner,
    EventDetailsSection,
    EventDetailsSectionTitle,
} from '../EventDetails';
import type { DateAndTimeProps } from './DateAndTime/DateAndTime';
import { DateAndTime } from './DateAndTime/DateAndTime';
import type { LocationProps } from './Location/Location';
import { Location } from './Location/Location';
import { Map } from './Map/Map';

type WhenAndWhereProps = {
    dates: DateAndTimeProps;
    location: LocationProps;
    map: Omit<EventMapScopedProps, 'venueName' | 'venueAddress'>;
};

export const WhenAndWhere = ({ dates, location, map }: WhenAndWhereProps) => {
    const [isMapExpanded, setIsMapExpanded] = React.useState(true);

    return (
        <EventDetailsSection ariaLabelledBy="when-and-where">
            <EventDetailsMainInner>
                <EventDetailsSectionTitle>
                    <h2>{gettext('When and where')}</h2>
                </EventDetailsSectionTitle>

                <DetailList>
                    <DateAndTime {...dates} />
                    <Location
                        {...{
                            ...location,
                            onToggleButtonMap: setIsMapExpanded,
                            isMapExpanded: isMapExpanded,
                        }}
                    />
                </DetailList>
            </EventDetailsMainInner>
            {map.shouldDisplayMap && (
                <Map
                    location={map.location}
                    gMapsApiKey={map.gMapsApiKey}
                    mapZoom={DEFAULT_ZOOM}
                    isMapExpanded={isMapExpanded}
                />
            )}
        </EventDetailsSection>
    );
};
